// extracted by mini-css-extract-plugin
export default {"base":"vp__VWF6","lead":"vp_XpwPx","centerAlign":"vp_tcyzA","rightAlign":"vp_idPrg","noMargin":"vp_VvOZt"};